import ActivityTypeAction from "./ActivityTypeAction";
import BaseReducer from "../../utilities/BaseReducer";

export default class ActivityTypeReducer extends BaseReducer {
  initialState = {
    activityType: [],
  };

  [ActivityTypeAction.REQUEST_ACTIVITY_TYPE_FINISHED](state, action) {
    return {
      ...state,
      activityType: action.payload,
    };
  }
}
